import React from "react";
import { Link } from "react-router-dom";
import "../../src/app/styles/home.css";
import Navigation from "../app/components/Navigation";
import EventCallout from "../app/components/eventCallout";

const Home = () => {
  return (
    <main className="main">
      <Navigation showLinks={false} />
      <EventCallout />

      <div className="home-container">
        <div className="cards-container">
          <Link to="/library" className="card-link">
            <div className="card">
              <div className="card-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="-32 -24 64 50"
                  fill="currentColor"
                >
                  <path
                    stroke="none"
                    fill="#d4a17b"
                    d="M-1 24.85 Q-6.75 21.5 -19.05 21 -21.85 20.9 -25.05 20.95 L-26.95 21 -27.3 21 -27.95 21 -28 21 -28.3 21 -28.95 21 -29.95 20.75 -30.7 20.05 -31 19 -31 -17 Q-31 -17.85 -30.4 -18.4 -29.85 -19 -29 -19 L-26 -19 -26 11 Q-26 12.2 -25.15 13.1 L-25.05 13.2 Q-24.25 13.95 -23.1 14 L-18.05 14.3 Q-6.65 15.25 -1.3 17.8 L0 18.1 1.35 17.8 Q6.4 15.35 16.95 14.35 L23.15 14 Q24.15 13.95 24.95 13.3 L25.15 13.1 Q26 12.2 26 11 L26 -19 29 -19 Q29.85 -19 30.45 -18.4 31 -17.85 31 -17 L31 19 30.75 20.05 30 20.75 28.95 21 28.3 21 28 21 27.95 21 27.3 21 26.95 21 24.95 20.95 17.95 21.05 Q6.55 21.7 1.05 24.85 L0 25.1 -1 24.85 M0 13.1 Q-5.75 10.25 -21 9.1 L-22 9 -22 -23 -20.9 -22.9 Q-10.85 -22.1 -6.25 -21 -2.65 -20.15 -0.2 -19 L0 -18.9 0.25 -19 Q2.7 -20.15 6.3 -21 10.15 -21.9 22 -23 L22 9 17.95 9.4 Q5.35 10.45 0 13.1"
                  />
                </svg>
              </div>
              <h2 className="card-title">View Our Board Game Library</h2>
              <p className="card-description">
                Browse our complete collection of board games. Filter by
                category, player count, or difficulty.
              </p>
            </div>
          </Link>

          <Link to="/quiz" className="card-link">
            <div className="card">
              <div className="card-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="-30 -32 60 64"
                  fill="currentColor"
                >
                  <path
                    stroke="none"
                    fill="#d4a17b"
                    d="M2.9 -30.2 L24.05 -17.7 Q25.45 -16.9 26.2 -15.5 27 -14.15 27 -12.55 L27 12.5 Q27 14.1 26.2 15.5 25.45 16.85 24.05 17.65 L2.9 30.2 Q1.5 31 -0.05 31 -1.6 31 -2.95 30.2 L-24.1 17.65 Q-25.45 16.85 -26.25 15.5 -27 14.1 -27 12.5 L-27 -12.55 Q-27 -14.15 -26.25 -15.45 -25.45 -16.9 -24.1 -17.7 L-2.95 -30.2 Q-1.6 -31 -0.05 -31 1.5 -31 2.9 -30.2 M2.8 1.5 L1.6 2.8 Q1.2 4 -0.2 4 L-1 3.9 Q-1.8 3.6 -2.1 2.8 -2.4 2.1 -2.1 1.3 -1.5 0 0 -1.3 1.8 -3.3 1.8 -4 1.6 -6 -0.2 -6 -1.3 -6 -2 -5.1 -2.4 -4.4 -3.1 -4.1 L-4.6 -4.2 Q-5.3 -4.6 -5.6 -5.3 -5.9 -6.1 -5.5 -6.8 -3.9 -10 -0.2 -10 2.8 -10 4.5 -7.9 5.8 -6.2 5.8 -4 5.8 -1.5 2.8 1.5 M-4.8 0.05 L-4.9 0.25 Q-5.6 2.15 -4.9 3.85 L-4.85 4 -4.6 4.5 Q-5.2 5.45 -5.2 7 L-5.2 9 Q-5.2 13 -1.2 13 L0.8 13 Q4.8 13 4.8 9 L4.8 7 Q4.8 5.4 4.2 4.45 L5 3.55 4.95 3.65 Q9 -0.45 8.8 -4 8.8 -7.25 6.9 -9.7 L6.85 -9.75 Q4.3 -13 -0.2 -13 -5.7 -13 -8.1 -8.3 -9.2 -6.4 -8.4 -4.25 L-8.35 -4.1 Q-7.7 -2.5 -6.1 -1.6 -5.2 -1.1 -4.25 -0.95 L-4.8 0.05 M1.8 9 Q1.8 10 0.8 10 L-1.2 10 Q-2.2 10 -2.2 9 L-2.2 7 Q-2.2 6 -1.2 6 L0.8 6 Q1.8 6 1.8 7 L1.8 9"
                  />
                </svg>
              </div>
              <h2 className="card-title">Need A Game Recommendation?</h2>
              <p className="card-description">
                Take our AI quiz and get personalized recommendations from our
                library based on your preferences.
              </p>
            </div>
          </Link>
          <div className="card-link">
            <div className="card">
              <div className="card-icon">
                <svg viewBox="-24 -24 48 48">
                  <path
                    stroke="none"
                    fill="#d4a17b"
                    d="M-23.45 4.9 Q-19.7 -3.1 -14.05 -7.5 -11.9 -9.3 -10.25 -10.2 -8.5 -11.2 -8.85 -13.2 L-9 -15 Q-9 -18.7 -6.35 -21.35 -3.75 -24 0 -24 3.7 -24 6.35 -21.35 9 -18.7 9 -15 L8.8 -13.2 Q8.5 -11.2 10.25 -10.2 11.85 -9.3 14.05 -7.5 19.75 -3.1 23.45 4.9 L23.95 6.75 24 7.4 23.75 8.85 23.7 9.05 22.75 10.45 Q21.45 11.7 19.7 11.7 17.95 11.7 16.65 10.45 L16.2 9.9 13.55 5.7 13.45 5.6 13.3 5.45 Q12.95 5.05 12.4 5.05 11.85 5.05 11.45 5.45 11.1 5.8 11.1 6.35 L11.1 6.4 Q11.1 7.6 13.1 12.3 15.1 16.95 15.85 19.75 L15.85 19.95 16 20.8 Q15.95 22.1 15.2 22.85 L13.75 23.85 12.7 24 11.6 24 5.45 24 5.35 24 Q4.35 24 3.6 23.5 L3.05 23.05 2.55 22.45 2.2 21.5 2.05 20.9 1 14.95 1 14.9 0.7 14.35 Q0.4 14.05 0 14.05 -0.45 14.05 -0.75 14.35 L-1 14.9 -1 14.95 -2.05 20.9 -2.2 21.5 -2.6 22.45 -3.05 23.05 -3.6 23.5 Q-4.4 24 -5.35 24 L-5.45 24 -11.6 24 -12.75 24 -13.8 23.85 -15.2 22.85 Q-15.95 22.1 -16 20.8 L-15.9 19.95 -15.85 19.75 Q-15.15 16.95 -13.1 12.3 -11.15 7.6 -11.15 6.4 L-11.15 6.35 Q-11.15 5.8 -11.45 5.45 -11.9 5.05 -12.4 5.05 -12.95 5.05 -13.3 5.45 L-13.45 5.6 -13.55 5.7 -16.25 9.9 -16.7 10.45 Q-17.95 11.7 -19.7 11.7 -21.5 11.7 -22.75 10.45 L-23.75 9.05 -23.75 8.85 -24 7.4 -24 6.75 -23.45 4.9"
                  />
                </svg>
              </div>
              <h2 className="card-title">Connect With Us</h2>
              <ul className="social-links card-links">
                <li>
                  <a
                    href="https://instagram.com"
                    target="_blank"
                    className="social-link"
                    rel="noopener noreferrer"
                  >
                    <svg
                      className="social-icon"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                        fill="currentColor"
                      />
                    </svg>
                    Instagram
                  </a>
                </li>
                 <li>
                  <a
                    href="https://discord.com"
                    className="social-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      className="social-icon"
                      
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.317 4.37a19.791 19.791 0 00-4.885-1.515.074.074 0 00-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 00-5.487 0 12.64 12.64 0 00-.617-1.25.077.077 0 00-.079-.037A19.736 19.736 0 003.677 4.37a.07.07 0 00-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 00.031.057 19.9 19.9 0 005.993 3.03.078.078 0 00.084-.028c.462-.63.874-1.295 1.226-1.994a.076.076 0 00-.041-.106 13.107 13.107 0 01-1.872-.892.077.077 0 01-.008-.128 10.2 10.2 0 00.372-.292.074.074 0 01.077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 01.078.01c.12.098.246.198.373.292a.077.077 0 01-.006.127 12.299 12.299 0 01-1.873.892.077.077 0 00-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 00.084.028 19.839 19.839 0 006.002-3.03.077.077 0 00.032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 00-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.955-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.946 2.418-2.157 2.418z"
                        fill="currentColor"
                      />
                    </svg>
                    Discord
                  </a>
                </li>
                 <li>
                  <a
                    href="https://boardgamegeek.com"
                    target="_blank"
                    className="social-link"
                    rel="noopener noreferrer"
                  >
           <svg height="38" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 38" width="30"><g fill="none" fill-rule="evenodd"><polygon fill="currentColor" points="24.87 7.01 21.107 8.035 24.792 0 .9 8.794 2.206 19.327 0 21.454 6.577 37.93 20.558 32.779 25.418 21.37 23.331 19.358"></polygon></g></svg>
                    BoardGameGeek
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Home;
